var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fixo-topo" },
    [
      _c("q-card", { staticClass: "gvn-breadcrumb" }, [
        _c(
          "ul",
          { staticClass: "breadcrumb" },
          _vm._l(_vm.paginas, function(pagina) {
            return _vm.paginas
              ? _c(
                  "li",
                  {
                    key: pagina.id,
                    on: {
                      click: function($event) {
                        _vm.abrirPagina(pagina.rotaNome)
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      [
                        _c("q-icon", {
                          class: pagina.classe,
                          staticStyle: { "font-size": "20px" },
                          attrs: { name: pagina.icone }
                        }),
                        _c("span", [_vm._v(_vm._s(pagina.descricao))])
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          })
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }